module.exports = __webpack_public_path__ + "img/antecedentes.d3c90f38.png";